export * from './DoubleChevronRightIcon'
